import {Card, CardActions, CardContent, Link, Box, Typography, TypographyProps} from '@mui/material';
import {styled} from '@mui/material/styles';

import {zIndexes} from '../../constants';

export const StyledCard = styled(Card)<{isReactNativeView?: boolean}>(({isReactNativeView, theme}) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  borderRadius: 0,
  boxShadow: 'none',
  padding: isReactNativeView ? theme.spacing(1, 0) : theme.spacing(2, 0)
}));

export const StyledProductCard = styled(Box)<{isReactNativeView?: boolean}>(({isReactNativeView}) => ({
  display: 'flex',
  gap: isReactNativeView ? '6px' : 'none'
}));

export const StyledCardContentWrapper = styled(Box)(({theme}) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  padding: theme.spacing(0),
  '& > div:last-child': {
    flex: 1,
    maxWidth: '100%'
  }
}));

export const StyledBasketProductImage = styled(Box)(({theme}) => ({
  width: 64,
  height: 64,
  position: 'relative',
  overflow: 'hidden',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.grey[50]
}));

export const StyledRibbons = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  position: 'absolute',
  zIndex: zIndexes.zIndexOne
}));

export const StyledDivider = styled(Box)(({theme}) => ({
  width: theme.spacing(0.1875),
  height: theme.spacing(1.75),
  backgroundColor: theme.palette.grey[200],
  fontSize: theme.spacing(2),
  marginLeft: theme.spacing(1),
  marginRight: theme.spacing(1),
  marginTop: theme.spacing(0.25)
}));

export const QuantityChangeLabel = styled(Box)(({theme}) => ({
  color: theme.palette.primary.main,
  padding: theme.spacing(0, 1.3, 0, 0)
}));

export const StyledCardContent = styled(CardContent)<{isReactNativeView?: boolean; isProductUnavailable?: boolean}>(
  ({theme, isReactNativeView, isProductUnavailable}) => ({
    padding: theme.spacing(0),
    opacity: isProductUnavailable ? '0.5' : '1',
    '&.MuiCardContent-root': {
      padding: isReactNativeView ? '0px' : theme.spacing(0, 2, 0, 2)
    }
  })
);
export const StyledCardContentUnpadded = styled(Box)<{
  isProductUnavailable?: boolean;
}>(({theme, isProductUnavailable}) => ({
  padding: theme.spacing(0),
  opacity: isProductUnavailable ? '0.5' : '1'
}));

export const StyledCardActions = styled(CardActions)<{isReactNativeView?: boolean}>(({theme, isReactNativeView}) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  padding: isReactNativeView ? '6px 0px 0px 0px' : theme.spacing(1, 0),
  [theme.breakpoints.down(326)]: {
    flexDirection: 'column'
  }
}));

export const StyledTitleTypographyWrapper = styled(Link)(() => ({
  textDecoration: 'none',
  cursor: 'pointer',
  display: 'block'
}));
export const ProductAttributesBox = styled(Box)(({theme}) => ({
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5)
}));

export const StyledTitleTypography = styled(Typography)<TypographyProps>(({theme}) => ({
  textDecoration: 'none',
  display: 'block',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  width: '100%',
  fontSize: theme.spacing(1.75),
  [theme.breakpoints.down('md')]: {
    maxWidth: theme.spacing(45)
  },
  [theme.breakpoints.down('sm')]: {
    maxWidth: theme.spacing(32)
  },
  [theme.breakpoints.down(513)]: {
    maxWidth: theme.spacing(25)
  },
  [theme.breakpoints.down(490)]: {
    maxWidth: theme.spacing(22)
  },
  [theme.breakpoints.down(463)]: {
    maxWidth: theme.spacing(20)
  },
  [theme.breakpoints.down(395)]: {
    maxWidth: theme.spacing(15.5)
  },
  [theme.breakpoints.down(375)]: {
    maxWidth: theme.spacing(10)
  },
  [theme.breakpoints.down(330)]: {
    maxWidth: theme.spacing(8.5)
  }
}));

export const AvailableProductsTitle = styled(Typography)<TypographyProps & {isReactNativeView?: boolean}>(
  ({theme}) => ({
    textDecoration: 'none',
    display: 'block',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    width: '400px',
    fontSize: theme.spacing(1.75),

    [theme.breakpoints.down('md')]: {
      maxWidth: theme.spacing(45)
    },
    [theme.breakpoints.down(490)]: {
      maxWidth: theme.spacing(40)
    },
    [theme.breakpoints.down(460)]: {
      maxWidth: theme.spacing(38)
    },

    [theme.breakpoints.down(435)]: {
      maxWidth: theme.spacing(34)
    },
    [theme.breakpoints.down(410)]: {
      maxWidth: theme.spacing(32)
    },
    [theme.breakpoints.down(395)]: {
      maxWidth: theme.spacing(29)
    },
    [theme.breakpoints.down(370)]: {
      maxWidth: theme.spacing(26)
    },
    [theme.breakpoints.down(345)]: {
      maxWidth: theme.spacing(23)
    }
  })
);

export const StyledAddToCartButtonWrapper = styled(Box)(() => ({
  width: 'fit-content'
}));

export const StyledQuantityWrapper = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'row',
  borderRadius: '4rem',
  border: `1px solid ${theme.palette.primary.main}`,
  maxWidth: theme.spacing(20),
  color: theme.palette.primary.main,

  '& > input': {
    border: 0,
    outline: 'none',
    maxWidth: '78px',
    textAlign: 'center',
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.fontSize,
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.common.white
  },
  '& > button:hover': {
    color: theme.palette.common.black
  },
  '&.disabled': {
    borderColor: theme.palette.grey[200],
    '& > input': {
      color: theme.palette.grey[200],
      userSelect: 'none'
    }
  },
  '& > input[type=number]::-webkit-inner-spin-button, input[type=number]::-webkit-outer-spin-button': {
    '-webkit-appearance': 'none',
    '-moz-appearance': 'none',
    appearance: 'none',
    margin: 0
  }
}));

export const QuantityAdjustedText = styled(Box)<{isReactNativeWebView?: boolean}>(({theme, isReactNativeWebView}) => ({
  color: theme.palette.primary.main,
  marginRight: isReactNativeWebView ? '0' : theme.spacing(2),
  fontSize: theme.typography.caption.fontSize
}));

export const QuantitySectionStyled = styled(Box)<{isReactNativeWebView?: boolean}>(({isReactNativeWebView}) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: isReactNativeWebView ? 'column-reverse' : 'row',
  marginLeft: '0px !important',
  marginRight: isReactNativeWebView ? '2px' : '0px'
}));

export const StyledTooltipText = styled(Typography)(({theme}) => ({
  fontSize: theme.spacing(1.7),
  padding: theme.spacing(0.5),
  [theme.breakpoints.down('tablet')]: {
    fontSize: theme.spacing(1.6),
    padding: '2px'
  }
}));

export const StyledPerUnitPriceText = styled(Typography)(({theme}) => ({
  color: theme.palette.grey[400]
}));

export const BasketCardContent = styled(StyledCardContent)(() => ({
  maxWidth: '40%',
  flexGrow: 1
}));

export const QuantityWrapper = styled('div')(() => ({
  alignSelf: 'center'
}));

export const ProductItemUnavailableDiv = styled('div')(() => ({
  background: '#F4F4F4',
  borderRadius: '24px',
  padding: '7px 17px',
  fontSize: '12px',
  color: '#8E8E8E',
  width: 'max-content'
}));

export const VoucherPriceTagDetail = styled(Box)(({theme}) => ({
  backgroundColor: theme.palette.common.mds_global_color_red_5,
  padding: theme.spacing(0.25, 0.75),
  color: theme.palette.common.mds_global_color_red_25,
  fontSize: '10px',
  display: 'inline-flex',
  cursor: 'pointer',
  alignItems: 'center',
  gap: theme.spacing(0.75),
  fontWeight: 600,
  justifySelf: 'flex-start',
  borderRadius: theme.spacing(0.5)
}));
